module.exports = __webpack_public_path__ + "img/qrCode.c8fa084b.png";